import { render, staticRenderFns } from "./award-list.vue?vue&type=template&id=40fc1f39&scoped=true"
import script from "./award-list.vue?vue&type=script&lang=js"
export * from "./award-list.vue?vue&type=script&lang=js"
import style0 from "./award-list.vue?vue&type=style&index=0&id=40fc1f39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc1f39",
  null
  
)

export default component.exports